module.exports = __webpack_public_path__ + "img/hr-red-desert-bush-00.4e728079.png";